<template>
<div class='h-width-100p h-height-100p h-flex'>
    <LeafletMap
        class='h-width-100p b-edit-form__preview__map'>
    </LeafletMap>
</div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-facing-decorator';
import { LeafletMap } from '@/components/common/LeafletMap';

@Component({
    components: { LeafletMap },
})
export default class CalendarMapTestPage extends Vue {

}
</script>

<style lang='sass'></style>
